import trackEvent from './trackEvent'
/**
 * @param {String} feature
 * @param {String} action
 */
export default function logClickEvent(feature, action, label) {
  trackEvent(feature, action, label)
}
